uniform float uTime;
uniform float uDeltaTime;
uniform sampler2D uBase;
uniform float uFlowFieldInfluence;
uniform float uFlowFieldStrength;
uniform float uFlowFieldFrequency;

#include ../includes/simplexNoise4d.glsl

void main() {
  float time = uTime * 0.2;
  vec2 uv = gl_FragCoord.xy / resolution.xy;
  vec4 particle = texture(uParticles, uv);
  vec4 base = texture(uBase, uv);

  // Dead
  if (particle.a >= 1.0) {
    particle.a = mod(particle.a, 1.0); 
    particle.xyz = base.xyz;
  }

  // Alive
  else {
    // Strength
    float strengthMultiplier = 2.5; 

    float strength = simplexNoise4d(vec4(base.xyz * strengthMultiplier, time + 3.0)); 
    float influence = (uFlowFieldInfluence - 0.5) * (- 2.0); 
    strength = smoothstep(influence, 1.0, strength);
    
    // Flow field 
    vec3 flowField = vec3(
      simplexNoise4d(vec4(particle.xyz * uFlowFieldFrequency + 0.0, time * uFlowFieldFrequency)),
      simplexNoise4d(vec4(particle.xyz * uFlowFieldFrequency + 1.0, time * uFlowFieldFrequency)),
      simplexNoise4d(vec4(particle.xyz * uFlowFieldFrequency + 2.0, time * uFlowFieldFrequency))
    );

    flowField = normalize(flowField);

    particle.xyz += flowField *  uDeltaTime  * strength * uFlowFieldStrength;

    // Decay
    particle.a += uDeltaTime * 0.15;
  }

  gl_FragColor = particle; 
}

